import { Container, Typography } from '@material-ui/core';
import { Instagram, Facebook, WhatsApp } from '@material-ui/icons';

import useStyles from './styles';

const Footer = () => {
	const classes = useStyles();

	return (
		<>
			<footer className={classes.footerContainer}>
				<Container className={classes.footerContainers}>
					<Typography
						className={classes.footerTitles}
						align="center"
						variant="h4"
					>
						Acerca de
					</Typography>
					<Typography align="justify" variant="subtitle1">
						Marv's Bakery es un pequeño emprendimiento de repostería con un
						toque caribeño. Ofrecemos los mejores productos, con los mejores
						ingredientes y los mejores precios.
					</Typography>
				</Container>
				<Container className={classes.footerContainers}>
					<Typography
						className={classes.footerTitles}
						align="center"
						variant="h4"
					>
						Redes Sociales
					</Typography>
					<Container className={classes.buttons}>
						<a
							className={classes.button}
							href="https://www.instagram.com/marvs_bakery/?hl=es-la"
						>
							<Instagram style={{ fontSize: '3rem' }} />
						</a>
						<a
							className={classes.button}
							href="https://www.facebook.com/Marvs-Bakery-271984923472963"
						>
							<Facebook style={{ fontSize: '3rem' }} />
						</a>
						<a className={classes.button} href="https://wa.link/glbj57">
							<WhatsApp style={{ fontSize: '3rem' }} />
						</a>
					</Container>
				</Container>
				<Container className={classes.footerContainers}>
					<Typography
						className={classes.footerTitles}
						align="center"
						variant="h4"
					>
						Información
					</Typography>
					<Typography align="center" variant="subtitle1">
						Correo: jahirgabvalmur@gmail.com
					</Typography>
					<Typography align="center" variant="subtitle1">
						Número de teléfono: 8540-7642
					</Typography>
				</Container>
			</footer>
		</>
	);
};

export default Footer;
